/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {Stage, State} from '../../../model';
import {StageService} from '../../../services';
import { ReportService } from 'src/app/services/report.service';
import { ReportDelay, DelayType } from 'src/app/model/report';

@Component({
  selector: 'progress-indicator',
  templateUrl: './progress-indicator.component.html',
  styleUrls: ['./progress-indicator.component.scss']
})
export class ProgressIndicatorComponent implements OnInit, OnDestroy {
  @Input() stage: Stage;
  @Input() state: State;
  @Input() delay: ReportDelay;
  @Input() id: string;

  stages: Stage[];
  stagesSub: any;
  reportStageSub: any;

  delayType = DelayType;

  constructor(
    public stageService: StageService,
    public reportService: ReportService,

  ) {}

  ngOnInit(): void {
    this.stagesSub = this.stageService.stages$.subscribe(stage => this.stages = stage.filter(s => s.FLOW_SKIP !== true));
  }

  ngOnDestroy(): void {
    if (this.stagesSub)
      this.stagesSub.unsubscribe();
  }


}
